import { reverse } from 'named-urls'
import type { LinkProps, Location } from 'react-router-dom'

import { routing } from '@utils/routing'

import type { ReportType } from '../../../Analytics.types'
import { removeFiltersParams } from '../../../modules/AnalyticsFilters/utils/removeFiltersParams'

type AdditionalParams = Record<string, string | string[] | undefined>

export const createGetReportTo =
  (location: Location) =>
  (reportType: ReportType, additionalParams?: AdditionalParams): LinkProps['to'] | undefined => {
    const searchParams = new URLSearchParams(location.search)
    const cleanedParams = removeFiltersParams(searchParams)

    if (additionalParams) {
      Object.entries(additionalParams).forEach(([key, value]) => {
        if (value !== undefined) {
          if (Array.isArray(value)) {
            cleanedParams.set(key, value.join(','))
          } else {
            cleanedParams.set(key, value)
          }
        }
      })
    }

    return {
      pathname: reverse(routing.analytics.overview.report.self, { reportType }),
      search: cleanedParams.toString(),
    }
  }
